import { PrescriptionStatus } from '~/app/enums/PrescriptionStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';
import { AcknowledgeItem } from '~/app/services/activity-log.service';
import { NotificationsStore } from '~/app/store/notification.store';
import { jobNotResolved } from './TherapyJobNotResolved';

export const therapyJobUpdated = (store: NotificationsStore, tj: Partial<TherapyJobV2>) => {
  const acknowledgement: AcknowledgeItem = store.acknowledgments()?.[tj.id];

  return (
    jobNotResolved(tj) &&
    !!acknowledgement &&
    !acknowledgement?.therapyJobDeleted &&
    (tj.prescriptionStatus === PrescriptionStatus.ACTIVE || tj.prescriptionStatus === PrescriptionStatus.ON_HOLD)
  );
};
